import { actionSet, resolve, reject } from './utils'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { push } from 'react-router-redux'
import { isEmpty } from 'utils/validations'

import {
  FETCH_SUGGESTIONS_REQUEST,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_ERROR,
  UPDATE_SUGGESTION_REQUEST,
  UPDATE_SUGGESTION_SUCCESS,
  UPDATE_SUGGESTION_ERROR,
  GET_SUGGESTION_FROM_LIST,
  RESET_SUGGESTIONS,
  RESET_EDIT_SUGGESTION,
  GET_PAGES,
  SAVE_SUGGESTIONS_FILTERS,
  RESET_SUGGESTIONS_FILTERS,
  DELETE_SUGGESTION_REQUEST,
  DELETE_SUGGESTION_SUCCESS,
  DELETE_SUGGESTION_ERROR,
} from 'actionTypes'

const getPages = (page, data, dispatch) => {
  const qtt = data.length
  const qtd = 10
  let pages = Math.floor(qtt / qtd)
  /* istanbul ignore else */
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchSuggestionsSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}

/*
 * REQUEST MENU_SUGGESTIONS
 */
export const fetchSuggestions =
  (filters, token, page = 1) =>
  (dispatch) => {
    dispatch(fetchSuggestionsRequest())

    const baseUrl = API_URL.SUGGESTION_LIST
    let parametersUrl = ''

    /* istanbul ignore else */
    if (filters != null) {
      if (!isEmpty(filters.idBranch)) {
        parametersUrl = parametersUrl.concat(`&idBranch=${filters.idBranch}`)
      }
      if (!isEmpty(filters.dtStart)) {
        parametersUrl = parametersUrl.concat(`&dtInitial=${filters.dtStart}`)
      }
      if (!isEmpty(filters.dtEnd)) {
        parametersUrl = parametersUrl.concat(`&dtFinal=${filters.dtEnd}`)
      }
      if (!isEmpty(filters.cdStatus)) {
        parametersUrl = parametersUrl.concat(`&isAnswered=${filters.cdStatus}`)
      }

      parametersUrl = parametersUrl.replace('&', '?')
    }

    return new Api(token, dispatch)
      .get(baseUrl + parametersUrl)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(page, response.data, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchSuggestionsError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchSuggestionsRequest = () => ({
  type: FETCH_SUGGESTIONS_REQUEST,
})

export const fetchSuggestionsSuccess = (data, dispatch) => {
  /* istanbul ignore else */
  if (data) {
    dispatch(suggestionsSuccess(data))
  }

  dispatch(hideSpinner())
}

const suggestionsSuccess = (data) => ({
  type: FETCH_SUGGESTIONS_SUCCESS,
  payload: data,
})

export const fetchSuggestionsError = (error) => ({
  type: FETCH_SUGGESTIONS_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE SUGGESTION
 */
export const update = (token, fields) => (dispatch) => {
  dispatch(updateMissionRequest())

  return new Api(token, dispatch)
    .post(API_URL.SUGGESTION_SAVE, fields)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateMissionSuccess(response.data))
      dispatch(push('/suggestions'))
    })
    .catch((error) => {
      dispatch(updateMissionError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}

export const updateShow = (token, fields) => (dispatch) => {
  dispatch(updateMissionRequest())

  return new Api(token, dispatch)
    .post(API_URL.SUGGESTION_SAVE, fields)
    .then((response) => {
      dispatch(updateMissionSuccess(response.data))
    })
    .catch((error) => {
      dispatch(updateMissionError(error))
    })
}

export const updateMissionRequest = () => ({
  type: UPDATE_SUGGESTION_REQUEST,
})

export const updateMissionSuccess = (data) => ({
  type: UPDATE_SUGGESTION_SUCCESS,
  payload: data,
})

export const updateMissionError = (error) => ({
  type: UPDATE_SUGGESTION_ERROR,
  payload: error,
})

/*
 * GET SUGGESTION FROM LIST
 */
export const getSuggestion = (index) => (dispatch) => {
  dispatch({
    type: GET_SUGGESTION_FROM_LIST,
    index,
  })

  dispatch(push(`/suggestions/${index}`))
}

export const resetSuggestions = () => ({
  type: RESET_SUGGESTIONS,
})

export const resetEditSuggestions = () => ({
  type: RESET_EDIT_SUGGESTION,
})

/*
 * MANAGE FILTERS
 */
export const saveSuggestionsFilters = (filters) => (dispatch) => {
  dispatch({
    type: SAVE_SUGGESTIONS_FILTERS,
    payload: filters,
  })
}

export const resetSuggestionsFilters = () => (dispatch) => {
  dispatch({
    type: RESET_SUGGESTIONS_FILTERS,
  })
}

export const deleteSuggestion = (token, data) => async (dispatch) => {
  dispatch(actionSet(DELETE_SUGGESTION_REQUEST))
  dispatch(showSpinner())

  const query = {
    idSuggestion: data.idSuggestion,
  }

  try {
    const { data } = await new Api(token, dispatch).post(
      API_URL.SUGGESTION_DELETE,
      query
    )

    return resolve(dispatch, DELETE_SUGGESTION_SUCCESS, data)
  } catch (error) {
    return reject(dispatch, DELETE_SUGGESTION_ERROR, error)
  } finally {
    dispatch(hideSpinner())
  }
}
